import React, { useState, useEffect } from 'react';
import { Row, Col, Descriptions, Tabs, Card } from "antd";
import moment from 'moment';

import { FormatFone, MaskFormat } from '../../ValueObjects/';
import { TabDetalheItens, TabDetalheIFormaPagamento } from './tabPage';
import api from '../../services/api';
import { HasValue } from '../../services/funcoes';

export default function DetalheNotaFiscal({ dadosModal }) {

    const [abaSelecionada, setAbaSelecionada] = useState("1");
    const [detalheNotaFiscal, setDetalheNotaFiscal] = useState({});
    const [arrFinalidade] = useState(["NF-E NORMAL", "NF-E COMPLEMENTAR", "NF-E DE AJUSTE", "DEVOLUÇÃO"]);
    const [arrAmbiente] = useState(["PRODUÇÃO", "HOMOLOGAÇÃO"]);
    const [modalidadesFrete, setModalidadesFrete] = useState([]);
    const [indPresenca, setIndPresenca] = useState([]);
    const [status, setStatus] = useState([]);

    useEffect(() => {
        if (!!dadosModal) {
            buscarEnuns();
            setDetalheNotaFiscal(dadosModal);
        }
    }, [dadosModal]);

    function buscarEnuns() {
        api.get(`Enum/Listar?nome=ModalidadeFrete`).then(
            res => {
                setModalidadesFrete(res.data);
            }
        ).catch(
            erro => {
                console.log(erro);
            }
        )

        api.get(`Enum/Listar?nome=IndicadorPresenca`).then(
            res => {
                setIndPresenca(res.data);
            }
        ).catch(
            erro => {
                console.log(erro);
            }
        )

        api.get(`Enum/Listar?nome=StatusNFe`).then(
            res => {
                setStatus(res.data);
            }
        ).catch(
            erro => {
                console.log(erro);
            }
        )
    };

    function getDescricaoEnum(lista, key) {
        const item = lista.find(x => x.key === key);
        return item ? item.value : "Desconhecido";
    }

    function displayValue(value, fallback = "NÃO INFORMADO") {
        return value ? value : fallback;
    }

    return (
        <div>
            <Card title="Identificação do Destinatário"
                size='small'
                className='card-top'
                styles={{ header: { backgroundColor: '#f1f1f1' } }}
            >
                <Descriptions column={3} size='small' labelStyle={{ fontWeight: 'bold' }}>
                    <Descriptions.Item label="Nome">{displayValue(detalheNotaFiscal.ntf_nomedest)}</Descriptions.Item>
                    <Descriptions.Item label="CPF/CNPJ">{displayValue(detalheNotaFiscal.ntf_cnpjcpfdest)}</Descriptions.Item>
                    <Descriptions.Item label="IE">{displayValue(detalheNotaFiscal.ntf_iedest)}</Descriptions.Item>
                    <Descriptions.Item label="E-mail">{displayValue(detalheNotaFiscal.ntf_emaildest)}</Descriptions.Item>
                    <Descriptions.Item label="Telefone">{displayValue(detalheNotaFiscal.ntf_telefonedest)}</Descriptions.Item>
                </Descriptions>
                <Descriptions size='small' labelStyle={{ fontWeight: 'bold' }}>
                    <Descriptions.Item label="Endereço">
                        {detalheNotaFiscal.ntf_logradourodest || 'NÃO INFORMADO'}
                        {detalheNotaFiscal.ntf_numeroenderecodest && `, Nº ${detalheNotaFiscal.ntf_numeroenderecodest}`}
                        {detalheNotaFiscal.ntf_bairrodest && `, ${detalheNotaFiscal.ntf_bairrodest}`}
                        {detalheNotaFiscal.ntf_municipiodest && ` - ${detalheNotaFiscal.ntf_municipiodest}`}
                        {detalheNotaFiscal.ntf_ufdest && `/${detalheNotaFiscal.ntf_ufdest}`}
                        {detalheNotaFiscal.ntf_cepdest && ` - CEP ${MaskFormat(detalheNotaFiscal.ntf_cepdest, '00000-000')}`}
                    </Descriptions.Item>
                </Descriptions>
            </Card>
            <Card title="Dados da Nota Fiscal"
                size="small"
                className='card-bottom'
                styles={{ header: { backgroundColor: '#f1f1f1', borderTopLeftRadius: 0, borderTopRightRadius: 0 } }}
            >
                <Descriptions column={4} size="small" labelStyle={{ fontWeight: 'bold' }}>
                    <Descriptions.Item label="Número">{detalheNotaFiscal.ntf_numero}</Descriptions.Item>
                    <Descriptions.Item label="Data de Emissão">{moment(detalheNotaFiscal.ntf_dataemissao).format('DD/MM/YYYY HH:mm')}</Descriptions.Item>
                    <Descriptions.Item label="Série">{detalheNotaFiscal.ser_serie} - {detalheNotaFiscal.mdf_descricao}</Descriptions.Item>
                    <Descriptions.Item label="Chave">{displayValue(detalheNotaFiscal.ntf_chavenfe, 'NÃO DISPONÍVEL')}</Descriptions.Item>
                    <Descriptions.Item label="Status">{getDescricaoEnum(status, detalheNotaFiscal.ntf_status)}</Descriptions.Item>
                    <Descriptions.Item label="Data Ent/Sai.">{HasValue(detalheNotaFiscal.ntf_dhsaient) ? moment(detalheNotaFiscal.ntf_dhsaient).format('DD/MM/YYYY HH:mm') : ""}</Descriptions.Item>
                    <Descriptions.Item label="Operação">{detalheNotaFiscal.ope_descricao}</Descriptions.Item>
                    <Descriptions.Item label="Protocolo">{displayValue(detalheNotaFiscal.ntf_protocolonfe, 'NÃO DISPONÍVEL')}</Descriptions.Item>
                    <Descriptions.Item label="Ambiente">{arrAmbiente[detalheNotaFiscal.ntf_ambiente - 1]}</Descriptions.Item>
                    <Descriptions.Item label="Data Inclusão">{moment(detalheNotaFiscal.ntf_datainclusao).format('DD/MM/YYYY HH:mm')}</Descriptions.Item>
                    <Descriptions.Item label="Finalidade">{arrFinalidade[detalheNotaFiscal.ntf_finalidade - 1]}</Descriptions.Item>
                    <Descriptions.Item label="Indicador de Destino">
                        {detalheNotaFiscal.ntf_identificadordestino == 1 ? "Estadual" : detalheNotaFiscal.ntf_identificadordestino == 2 ? "Interestadual" : "Exterior"}
                    </Descriptions.Item>
                    <Descriptions.Item label="Ind. Presença">
                        {getDescricaoEnum(indPresenca, detalheNotaFiscal.ntf_indicadorpresenca)}
                    </Descriptions.Item>
                    <Descriptions.Item label="Frete">
                        {getDescricaoEnum(modalidadesFrete, detalheNotaFiscal.ntf_modalidadefrete)}
                    </Descriptions.Item>
                </Descriptions>
                <Descriptions column={1} size="small" labelStyle={{ fontWeight: 'bold' }}>
                    <Descriptions.Item label="Informações Complementares">
                        {displayValue(detalheNotaFiscal.ntf_infcomplementar, '')}
                    </Descriptions.Item>
                </Descriptions>
            </Card>
            <div className="m-t-8">
                <Tabs type="card" centered activeKey={abaSelecionada} onChange={(tab) => setAbaSelecionada(tab)}>
                    <Tabs.TabPane tab="Itens" key="1">
                        <TabDetalheItens itensNF={detalheNotaFiscal.itensNf} />
                    </Tabs.TabPane>
                    <Tabs.TabPane tab="Formas de Pagamento" key="2">
                        <TabDetalheIFormaPagamento formaPagamento={detalheNotaFiscal.formaPgto} />
                    </Tabs.TabPane>
                </Tabs>
            </div>
        </div>
    );
}